enum TrackingEndpoint {
  SANDBOX = 'https://tracking.dev1.sandbox-ezcater.com',
  STAGING = 'https://tracking.staging-ezcater.com',
  PRODUCTION = 'https://tracking.ezcater.com',
}

export default TrackingEndpoint;
